import React, { useEffect, useState } from "react";
import { Trash2, Check, Copy, Instagram } from "lucide-react";
import { api } from "../lib/api";

export default function ConfessionsManager() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [copied, setCopied] = useState(null);

  const refresh = () => api.get("/confessions", { params: { limit: 200 } }).then((r) => setItems(r.data));

  useEffect(() => {
    refresh();
  }, []);

  const toggleShared = async (c) => {
    await api.patch(`/confessions/${c.id}?shared=${!c.shared}`);
    refresh();
  };

  const remove = async (c) => {
    if (!window.confirm("Supprimer cette confession ?")) return;
    await api.delete(`/confessions/${c.id}`);
    refresh();
  };

  const copy = async (c) => {
    await navigator.clipboard.writeText(c.text);
    setCopied(c.id);
    setTimeout(() => setCopied(null), 1500);
  };

  const filtered = items.filter((c) => (filter === "shared" ? c.shared : filter === "todo" ? !c.shared : true));

  return (
    <div data-testid="confessions-manager" className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="font-display text-3xl">Confessions ({items.length})</h2>
          <p className="text-sm text-black/60">
            Reçues anonymement. Copie le texte pour le publier sur Instagram, puis marque comme partagée.
          </p>
        </div>
        <div className="flex gap-2" data-testid="conf-filters">
          {[
            ["all", "Toutes"],
            ["todo", "À partager"],
            ["shared", "Partagées"],
          ].map(([k, l]) => (
            <button
              key={k}
              onClick={() => setFilter(k)}
              data-testid={`conf-filter-${k}`}
              style={
                filter === k
                  ? { background: "#050505", color: "#FFFDF7" }
                  : { background: "#FFFDF7", color: "#050505" }
              }
              className="px-4 py-2 rounded-full border-2 border-black text-xs font-bold uppercase tracking-widest"
            >
              {l}
            </button>
          ))}
        </div>
      </div>

      {filtered.length === 0 && (
        <p className="text-sm text-black/60 brutal-card p-6" style={{ background: "#FFFDF7" }}>
          Rien ici pour l&apos;instant. Les confessions des lecteurs apparaîtront ici en temps réel.
        </p>
      )}

      <div className="grid sm:grid-cols-2 gap-4">
        {filtered.map((c) => (
          <div
            key={c.id}
            data-testid={`confession-${c.id}`}
            className="brutal-card p-5 flex flex-col gap-3"
            style={{ background: c.shared ? "#D9C5FD" : "#FFFDF7" }}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs uppercase font-bold tracking-widest text-black/60">
                {new Date(c.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}
              </span>
              {c.mood && <span className="pill-tag bg-[#FFD01E]">{c.mood}</span>}
            </div>
            <p className="text-base leading-relaxed whitespace-pre-wrap">{c.text}</p>
            <div className="flex flex-wrap gap-2 mt-2">
              <button
                data-testid={`conf-copy-${c.id}`}
                onClick={() => copy(c)}
                className="brutal-btn brutal-btn-yellow !py-2 !px-3 !text-xs"
              >
                <Copy size={14} /> {copied === c.id ? "Copié !" : "Copier"}
              </button>
              <button
                data-testid={`conf-toggle-${c.id}`}
                onClick={() => toggleShared(c)}
                className={`brutal-btn !py-2 !px-3 !text-xs ${c.shared ? "brutal-btn-teal" : "brutal-btn-cream"}`}
              >
                <Check size={14} /> {c.shared ? "Partagée" : "Marquer partagée"}
              </button>
              <button
                data-testid={`conf-delete-${c.id}`}
                onClick={() => remove(c)}
                className="brutal-btn brutal-btn-coral !py-2 !px-3 !text-xs"
              >
                <Trash2 size={14} /> Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>

      <a
        href="https://instagram.com/bonsangmagazine"
        target="_blank"
        rel="noreferrer"
        className="brutal-btn brutal-btn-yellow self-start mt-4"
      >
        <Instagram size={16} /> Ouvrir Instagram pour publier
      </a>
    </div>
  );
}
